import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

const DishCard = ({
  title,
  description,
  image,
  productData = {},
  tag = "",
  onClick,
  link = "",
  state = {},
  priceList = [],
  showBadge = true,
  vTags,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Filter out empty productDimesion values
  const filteredPriceList = priceList.filter(
    (item) => item.productDimesion && item.productDimesion.trim() !== ""
  );

  // Auto-select first item with non-zero price
  useEffect(() => {
    if (filteredPriceList.length > 0) {
      const validIndex = filteredPriceList.findIndex(
        (item) => parseFloat(item.price) > 0
      );
      setSelectedIndex(validIndex !== -1 ? validIndex : 0);
    }
  }, [priceList]);

  const selectedItem = filteredPriceList[selectedIndex] || {};
  const selectedPrice = selectedItem.price || "0.00";
  const selectedDimension = selectedItem.productDimesion || "";
  const selectedMOQ = selectedItem.moq || "";

  return (
    <div className="dish-card">
      <div className="dish-image">
        {vTags?.split(",").some((tag) => tag.trim() === "Eco Friendly") && (
          <div className="badge">Eco Friendly</div>
        )}

        <img src={image} alt={title} className="product-image" />
        {productData?.vendorImage && (
          <img src={productData?.vendorImage} alt="" className="tag" />
        )}
      </div>

      <div className="dish-content">
        <h4 className="title">
          <Link to={`/${link}`} state={state}>
            {title}
            <FontAwesomeIcon
              icon={faChevronRight}
              className="pl-2 right-arrow"
            />
          </Link>
        </h4>
        {description && <p className="description">{description}</p>}

        <div className="new-flex">
          <p className="price">
            <span className="price">₹{selectedPrice}</span>/piece <br />
            {Number(selectedMOQ).toLocaleString("en-IN")} MOQ
          </p>

          {filteredPriceList.length > 0 && (
            <select
              className="form-select"
              value={selectedIndex}
              onChange={(e) => setSelectedIndex(parseInt(e.target.value))}
            >
              {filteredPriceList.map((item, idx) => (
                <option key={item.id} value={idx}>
                  {item.productDimesion}
                </option>
              ))}
            </select>
            // <div className="description">
            // </div>
          )}
        </div>

        <div className="dish-btn">
          <Link to={`/${link}`} state={state} className="btn btn-orange-light">
            Proceed to Enquire{" "}
            <FontAwesomeIcon icon={faChevronRight} className="right-arrow1" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DishCard;
